var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('label',{staticClass:"form-label"},[_vm._v(_vm._s(_vm.label || "Resultate"))]),_vm._v(" "),_c('input',{staticClass:"form-control",attrs:{"type":"number","min":0},domProps:{"value":_vm.value},on:{"input":_vm.emitFilter}})])
}
var staticRenderFns = []

export { render, staticRenderFns }